module.exports = __webpack_public_path__ + "static/img/logo@2x.570ef7e.webp";


//////////////////
// WEBPACK FOOTER
// ./static/webp2/logo@2x.webp
// module id = VnG4
// module chunks = 1